export const CONTROLS_TAB_LABELS = {
  NO_CONTROLS_TITLE: 'No controls assigned',
  NO_CONTROLS_SUBTITLE: "This project doesn't have any control scopes assigned.",
  GO_TO_PROJECT_SETTINGS: 'Go to project settings',
  VIEW_ALL_CONTROLS: 'View all controls',
  EVALUATE_ALL_CONTROLS: 'Evaluate all controls',
  EVALUATING_ALL_CONTROLS: 'Queuing...',
  EVALUATE_ALL_CONTROLS_CONFIRM_TITLE: 'Evaluate all controls',
  EVALUATE_ALL_CONTROLS_CONFIRM_CONTENT:
    'Re-runs the AI evaluation of every in-scope control in this assessment. Results arrive over the next few minutes.',
  EVALUATE_ALL_CONTROLS_CONFIRM_BUTTON: 'Evaluate',
} as const
